// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5866":"50ed3ac0","6518":"50ed3ac0","6759":"50ed3ac0"}[chunkId] + ".chunk.css";
};